<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T12:35:07+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Import Favicons
@Last modified by:   tom
@Last modified time: 2019-05-16T12:30:14+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

We use: https://github.com/Justineo/vue-awesome

  apply: npm install --save vue-awesome

  see: https://github.com/Justineo/vue-awesome

  demo: https://justineo.github.io/vue-awesome/demo/

  use in html:
    <icon name="flag" class="float-left"/>
    <icon class="text-secondary" name="flag" scale="2"/>

  search icons: https://fontawesome.com/icons?d=gallery&m=free

-->

<template lang="html">
  <div/>
</template>

<script>
import Vue from 'vue'
import Icon from 'vue-awesome/components/Icon'

// Common icons needed for List Bullets
import 'vue-awesome/icons/minus'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/info-circle'

// Load the PROJECT SPECIFIC icon imports
import './_icons-loader'
// Load the list helper to use icons in list with: <lii icon="circle">One item</lii>
import Lii from './_icons-li'
import Uli from './_icons-ul'

// Register all our icons globally
Vue.component('icon', Icon)
Vue.component('lii', Lii)
Vue.component('uli', Uli)

export default {
}

</script>

<style lang="scss" >

</style>
